import Home from "../../pages/home/Home";
import Contact from "../../pages/contact-us/Contact";
import Lending from "../../pages/lending/Lending";
import About from "../../pages/about-us/About";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import PropertyTypes from "../../pages/property types/PropertyTypes";
import  ApplicationForm from "../../pages/application-form/Application-Form";
import SubscriptionForm from "../../pages/subscription-form/subscription-form";
import TermsConditions from "../../pages/terms-conditions/terms-conditions";
import PrivacyPolicy from "../../pages/privacy-policy/privacy-policy";

export interface RouteObject {
  path: string;
  element: React.ReactNode;

}

export const ROUTES: RouteObject[] = [
  {
    path: "/",
    element: (
      <>
        <Navbar />
        <Home />
        <Footer />
      </>
    ),
  },
  {
    path: "/about",
    element: (
      <>
        <Navbar />
        <About />
        <Footer />
      </>
    ),
  },
  {
    path: "/contact",
    element: (
      <>
        <Navbar />
        <Contact />
        <Footer />
      </>
    ),
  },
  {
    path: "/lending",
    element: (
      <>
        <Navbar />
        <Lending />
        <Footer />
      </>
    ),
  },
  {
    path: "/property-types",
    element: (
      <>
        <Navbar />
        <PropertyTypes />
        <Footer />
      </>
    ),
  },  {
    path: "/loan-application-form",
    element: (
      <>
        <Navbar />
        <ApplicationForm />
        <Footer />
      </>
    ),
  },{
    path: "/subscription-agreement-application",
    element: (
      <>
        <Navbar />
        <SubscriptionForm />
        <Footer />
      </>
    ),
  },{
    path: "/terms-and-conditions",
    element: (
      <>
        <Navbar />
        <TermsConditions />
        <Footer />
      </>
    ),
  },{
    path: "/privacy-policy",
    element: (
      <>
        <Navbar />
        <PrivacyPolicy />
        <Footer />
        </>
    ),
  }
];
